/* eslint-disable import/no-default-export */
import Banner from 'app/common/components/banner/banner';
import * as React from 'react';

import { PrimaryButton } from 'app/common/components/controls/button/button';
import { BusinessBlue500 } from '@trello/colors';
import { forNamespace } from 'app/common/lib/util/i18n';
import InlineLink from '../billable-guests-alert/inline-link';
import styles from './notice-banner.less';
import { ButtonLink } from '../controls/link/link';

interface NoticeBannerProps {
  children: React.ReactNode;
  onDismiss?: () => void;
  inline?: boolean;
  learnMoreUrl?: string;
  actionButton?: {
    text: string;
    onClick: () => void;
  };
}

const learnMore = forNamespace()('learn more button');

const NoticeBanner = ({
  children,
  onDismiss,
  inline,
  actionButton,
  learnMoreUrl,
}: NoticeBannerProps) => {
  return (
    <Banner
      onDismiss={onDismiss}
      bannerColor={BusinessBlue500}
      useLightText
      roundedCorners={inline}
      inlinePadding={inline}
    >
      <div className={styles.noticeBannerContainer}>
        <div className={styles.textContent}>
          {children}{' '}
          {learnMoreUrl && inline && (
            <InlineLink text={learnMore} href={learnMoreUrl} />
          )}
        </div>
        {learnMoreUrl && !inline && (
          <div className={styles.learnMoreButton}>
            <ButtonLink link={learnMoreUrl} openInNewTab isPrimary={false}>
              {learnMore}
            </ButtonLink>
          </div>
        )}
        {actionButton && !inline && !learnMoreUrl && (
          <div className={styles.learnMoreButton}>
            <PrimaryButton onClick={actionButton.onClick} role="link">
              {actionButton.text}
            </PrimaryButton>
          </div>
        )}
      </div>
    </Banner>
  );
};

export default NoticeBanner;
